export function validateOrgno(input: string | null = '', countryCode: string, company = true) {
  const orgNo = input?.toString().replace(/[\s\-]/g, '');

  if (!orgNo || isNaN(Number(orgNo))) {
    return false;
  }

  switch (countryCode) {
    case 'NOR':
      //norweigan company
      if (input.length == 9) {
        let o = input.split('').map(i => {
          return parseInt(i, 10);
        });
        if (input.length == 9) {
          let sum = o[0] * 3 + o[1] * 2 + o[2] * 7 + o[3] * 6 + o[4] * 5 + o[5] * 4 + o[6] * 3 + o[7] * 2;
          let rest = sum % 11;
          let kontrollsiffer = rest === 0 ? 0 : 11 - rest;

          return rest != 1 && kontrollsiffer == o[8];
        } else {
          return false;
        }
      }
      //norweigan person
      else if (input.length == 11) {
        if (input.length != 11) return false;
        const staticSequenceFirstCheckDigit = [3, 7, 6, 1, 8, 9, 4, 5, 2, 1];
        const staticSequenceSecondCheckDigit = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2, 1];
        const elevenDigitsArray = input.split('').map(x => parseInt(x));

        const isValidCheckDigit = (staticSequence: any, digits: any) => {
          var productSum = staticSequence.reduce((acc: any, value: any, index: number) => acc + value * digits[index], 0);

          return productSum % 11 === 0;
        };

        return isValidCheckDigit(staticSequenceFirstCheckDigit, elevenDigitsArray) && isValidCheckDigit(staticSequenceSecondCheckDigit, elevenDigitsArray);
      } else {
        return false;
      }
    case 'SWE':
      //swedish person and company
      // Check valid length & form
      if (input.indexOf('-') === -1) {
        if (input.length === 10) {
          input = input.slice(0, 6) + '-' + input.slice(6);
        } else {
          input = input.slice(0, 8) + '-' + input.slice(8);
        }
      }
      if (!input.match(/^(\d{2})(\d{2})(\d{2})\-(\d{4})|(\d{4})(\d{2})(\d{2})\-(\d{4})$/)) {
        return false;
      }
      // Clean input
      input = input.replace('-', '');
      if (input.length === 12) {
        input = input.substring(2);
      }
      let sum = 0;
      // Check luhn algorithm
      for (let i = 0; i < input.length; i = i + 1) {
        let digit = parseInt(input.charAt(i), 10);
        if (i % 2 === input.length % 2) {
          digit *= 2;
        }
        if (digit > 9) {
          digit -= 9;
        }
        sum += digit;
      }
      return sum % 10 === 0;
    default:
      return true;
  }
}
